<template>
    <div class="convention-subjects-filter-container">
        <v-autocomplete
            v-model="excludedSubjects"
            :items="subjects"
            :search-input.sync="search"
            class="rounded-0 subjects-container"
            label="Absence de dispositions conventionnelles en prévoyance ou en santé"
            outlined
            dense
            hide-selected
            hide-details
            append-icon="mdi-chevron-down"
            item-text="label"
            item-value="code"
            no-data-text="Aucune convention collective ne correspond à votre recherche"
            :clearable="true"
        />
    </div>
</template>

<script>
export default {
    props: ["value", "annotationOptions", "subjects"],
    data() {
        return {
            search: null,
            excludedSubjects: this.value,
        };
    },
    watch: {
        async excludedSubjects(value) {
            this.$emit("input", value);
        },
        value(_value) {
            this.excludedSubjects = _value;
        },
    },
};
</script>

<style lang="sass" scoped>
.convention-subjects-filter-container
    display: flex
    align-items: center
    margin: 8px 0
</style>
